import React from 'react';
import { Card, Box, Typography, FormControl, Select, MenuItem, Grid, TextField } from '@mui/material';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

export default function WIPDetail({ processStep, setProcessStep, processSteps = [], startDate, setStartDate, endDate, disabled = false }) {
  return (
    <Card sx={{ width: '100%', height: '100%', p: { xs: 1.4, md: 1.75 }, borderRadius: 1.4, boxShadow: 'none', border: '1px solid #edf1f1', bgcolor: 'background.paper' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.95 }}>
        <LocalOfferOutlinedIcon sx={{ color: '#00B3BD', mr: 0.75, fontSize: 24 }} />
        <Typography variant="subtitle1" sx={{ fontWeight: 500, color: '#00B3BD', fontSize: 22 }}>WIP Production Detail</Typography>
      </Box>

      <Typography sx={{ mb: 0.4, color: '#111', fontSize: 20 }}>Process Step</Typography>
      <FormControl fullWidth sx={{ mb: 1.05 }}>
        <Select value={processStep} displayEmpty onChange={(e) => setProcessStep(e.target.value)} disabled={disabled} size="small" sx={{ height: 56, borderRadius: 1.1, '& .MuiSelect-select': { height: '56px', boxSizing: 'border-box', display: 'flex', alignItems: 'center', py: 0, fontSize: 20 } }}>
          <MenuItem value="">-</MenuItem>
          {processSteps.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>)}
        </Select>
      </FormControl>

      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <Typography sx={{ display: 'block', mb: 0.4, color: '#111', fontSize: 20 }}>Start Time</Typography>
            <TimePicker
              value={startDate}
              onChange={(newValue) => setStartDate(newValue)}
              disabled={disabled}
              ampm
              inputFormat="hh:mm a"
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  size="small"
                  sx={{
                    '& .MuiInputBase-root': { height: 56, borderRadius: 1.1 },
                    '& .MuiInputBase-input': { py: 0, fontSize: 20 },
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={6}>
            <Typography sx={{ display: 'block', mb: 0.4, color: '#111', fontSize: 20 }}>End Time</Typography>
            <TimePicker
              value={endDate}
              disabled
              ampm
              inputFormat="hh:mm a"
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  size="small"
                  sx={{
                    '& .MuiInputBase-root': { height: 56, borderRadius: 1.1 },
                    '& .MuiInputBase-input': { py: 0, fontSize: 20 },
                  }}
                />
              )}
            />
          </Grid>
        </Grid>
      </LocalizationProvider>
    </Card>
  );
}

